export const isCustomerGuest = () => window && window.isGuest;
